import { loggerFactory } from "@codametrix/ui-common";
const logger = loggerFactory('PageVisibilityAPI');
/**
 * Registers a listener for the visibilitychange event.
 * @param doc - The document object to register the listener on.
 */ export const registerVisibilityListener = (doc)=>{
    // this is exported as a function to be able to mock document in tests
    doc.addEventListener("visibilitychange", ()=>{
        logger.debug('visibilitychange', document.visibilityState);
    });
};
